import React from 'react';

export const PauseIcon = () => (
  <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 42 34" fill="none">
    <rect x="0.5" y="0.5" width="41" height="33" rx="3.5" fill="white" />
    <path d="M22.9 8.55H26.9V25.45H22.9V8.55Z" fill="currentColor" />
    <path d="M15.1 8.54999H19.1V25.45H15.1V8.54999Z" fill="currentColor" />
  </svg>
);
